import React from "react";
import { useForm } from "react-hook-form";

function QuestionsForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => console.log(data);
  console.log(errors);

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="w-full flex flex-col text-base md:text-xl gap-y-5"
    >
      <input
        className="bg-transparent border-b px-1"
        type="text"
        placeholder="Full name"
        {...register("Full name", { required: true, min: -1 })}
      />
      <input
        className="bg-transparent border-b px-1"
        type="text"
        placeholder="Email"
        {...register("Email", { required: true, pattern: /^\S+@\S+$/i })}
      />
      <input
        className="bg-transparent border-b px-1"
        type="text"
        placeholder="Message"
        {...register("Message", { required: true, maxLength: 200 })}
      />

      <input className="bg-black cursor-pointer md:mx-52 py-3 text-xl md:text-2xl rounded-xl hover:bg-slate-100 hover:bg-opacity-20" type="submit" />
    </form>
  );
}

export default QuestionsForm;
